import React, { useContext } from 'react'
import './Hero.sass'
import { withRouter } from 'react-router-dom'

import Icon from '../../ui/Icon/Icon'

import Button from '../../ui/Button/Button'
import heroBg from './assets/hero.png'
import { AuthContext } from '../../App'

function Hero() {
  const data = [
    { icon: 'wrench', title: 'Профессиональное оборудование' },
    { icon: 'clock', title: 'Полное соблюдение сроков работ' },
    { icon: 'shield-check', title: 'Гарантия лучшей цены' },
    { icon: 'credit-card', title: 'Удобная оплата' },
  ]

  const { setShowContactUs } = useContext(AuthContext)

  return (
    <div id="home" className="Site-Hero">
      <div
        className="HeroBg"
        style={{ backgroundImage: `url(${heroBg})` }}
      ></div>
      <div className="DefaultContainer">
        <div className="Offer">
          <h1 className="Title">Благоустройство территорий в Воронеже и ВО</h1>
          <p className="Description">
            Оформление газонов и кустарников, покос травы, спил деревьев, вывоз
            мусора
          </p>
          <div className="Benefits">
            {data.map((d) => (
              <Benefit {...d} />
            ))}
          </div>
          <div className="Buttons">
            <Button
              theme="primary"
              title="Заказать звонок"
              type="button"
              icon="phone"
              iconWeight="solid"
              size={48}
              onClick={() =>
                setShowContactUs({
                  show: true,
                  title: 'Заказать обратный звонок',
                  emailSubject: 'Заказ обратного звонка',
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

function Benefit({ icon, title }) {
  return (
    <div className="Benefit">
      <Icon name={icon} weight={'solid'} />
      <span>{title}</span>
    </div>
  )
}

export default withRouter(Hero)
